<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="用户昵称"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.phone"
                 placeholder="请输入手机号"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.orderNo"
                 placeholder="请输入订单号"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="请输入商品"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.status"
                  :label-in-value="true"
                  placeholder="请选择状态"
                  class="select"
          >
            <Option value="0" label="待付款"></Option>
            <Option value="1" label="待发货"></Option>
            <Option value="2" label="待收货"></Option>
            <Option value="10" label="已收货"></Option>
            <Option value="-1" label="失败"></Option>
            <Option value="-2" label="已退款"></Option>
            <Option value="-9" label="异常"></Option>
            <Option value="-12" label="取消"></Option>
            <Option value="-13" label="自动取消"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Date-picker
              ref="brithdayPicker"
              type="datetime"
              v-model="search.createTimeBegin"
              placeholder="请选择开始时间"
              style="width:150px"
          ></Date-picker>
        </div>
        <div class="search-item">
          <Date-picker
              ref="brithdayPicker"
              type="datetime"
              v-model="search.createTimeEnd"
              placeholder="请选择结束时间"
              style="width:150px"
          ></Date-picker>
        </div>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          ref="selection"
          @on-select="selectSupplier"
          @on-select-cancel="selectSupplier"
          @on-select-all="selectSupplier"
          @on-select-all-cancel="selectSupplier"
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>

    <Drawer title="" width="400" :closable="false" v-model="diyDom.showModal">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          {{ apiData.orderInfo.statusName }}
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            收货信息：
          </div>
          <div class="content-item-center">
            <p>{{ apiData.orderInfo.name }} {{ apiData.orderInfo.phone }}</p>
            <p>{{ apiData.orderInfo.address }}</p>
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            配送方式：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.homeDelivery == 1 ? '送货上门' : '快递配送' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            买家备注：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.buyerRemark || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title" style="line-height: 30px;">
            快递信息：
          </div>
          <div class="content-item-center"
               v-if="apiData.orderInfo.status==1||apiData.orderInfo.status==3||apiData.orderInfo.status==4">
            <Select clearable
                    style="width:100px;"
                    v-model="form.expressCompany"
                    @on-change="setCourierCompany"
                    allow-create
                    @on-create="handleCreate"
                    :label-in-value="true"
                    filterable
                    placeholder="请选择快递公司"
                    class="select"
            >
              <Option v-for="(item,index) in apiData.courierCompany" :key="index" :value="item.name">{{ item.name }}
              </Option>
            </Select>
            <Input clearable
                   v-model="form.deliveryNo"
                   placeholder="请输入快递单号"
                   style="width: 150px;"
            ></Input>
          </div>
          <template v-else>
            <div class="content-item-center" style="line-height: 30px;"
                 v-if="apiData.orderInfo.expressCompany||apiData.orderInfo.deliveryNo">
              {{ apiData.orderInfo.expressCompany }} {{ apiData.orderInfo.deliveryNo }}
            </div>
            <div class="content-item-center" style="line-height: 30px;" v-else>无</div>
          </template>
        </div>
        <Divider dashed/>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            订单号：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.orderNo || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            购买商品：
          </div>
          <div class="content-item-center">
            <div class="content-item-center-box" v-for="(item,index) in apiData.orderInfo.details" :key="index">
              <div class="content-item-center-box-title">
                {{ item.title }}
              </div>
              <div class="content-item-center-box-content">
                数量：x{{ item.num }}
              </div>
              <div class="content-item-center-box-content">
                模板：{{ item.templateName || '自定义模板' }}
              </div>
              <!-- <div v-if="item.replaceWord" class="content-item-center-box-content">
                替换文本：{{item.replaceWord}}
              </div>
               <div v-if="item.uploadFile" class="content-item-center-box-content">
                上传文件：<a href="javascript:;" @click="lookFile(item.uploadFile)">{{item.uploadFile}}</a>
              </div> -->
              <div class="content-item-center-box-content" v-if="item.skuInfo">
                规格：{{ item.skuInfo }}
              </div>
              <div class="content-item-center-box-content" v-if="item.processInfo">
                工序：{{ item.processInfo }}
              </div>
              <div class="content-item-center-box-content" v-if="item.designFile">
                  制作源文件：
                  <a href="javascript:;" @click="lookFile(item.designFile)">下载制作源文件</a>
              </div>
              <div class="content-item-center-box-content">
                <Button style="width: 90px" @click="lookShop(item)">查看详情</Button>
              </div>
            </div>
            <p>共{{ apiData.orderInfo.details.length }}件商品</p>
          </div>
        </div>
        <Divider dashed/>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            下单时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.createTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.sendTime">
          <div class="content-item-title">
            发货时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.sendTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.completeTime">
          <div class="content-item-title">
            完成时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.completeTime || '--' }}
          </div>
        </div>
        <Divider dashed/>
        <div v-if="apiData.orderInfo.status==1">
          <!-- 待发货 -->
          <Button style="width: 90px" @click="diyDom.showModal=false">取消</Button>
          <Button type="primary" style="width: 90px; margin-left: 20px" @click="getOrderinfoSendOut">发货</Button>
        </div>
        <div v-if="apiData.orderInfo.status==100">
          <!-- 带改价 -->
          <Button style="width: 90px" @click="diyDom.showModal=false">返回</Button>
          <Button type="primary" @click="getEnsurePrice()" style="width: 90px; margin-left: 20px">提交</Button>
        </div>
      </div>
    </Drawer>
    <Drawer title="" width="400" :closable="true" v-model="diyDom.showDelivery">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          {{ apiData.orderInfo.statusName }}
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            收货信息：
          </div>
          <div class="content-item-center">
            <p>{{ apiData.orderInfo.name }} {{ apiData.orderInfo.phone }}</p>
            <p>{{ apiData.orderInfo.address }}</p>
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            买家备注：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.buyerRemark || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title" style="line-height: 30px;">
            快递信息：
          </div>
          <template>
            <div class="content-item-center" style="line-height: 30px;"
                 v-if="apiData.orderInfo.expressCompany||apiData.orderInfo.deliveryNo">
              {{ apiData.orderInfo.expressCompany }} {{ apiData.orderInfo.deliveryNo }}
            </div>
            <div class="content-item-center" style="line-height: 30px;" v-else>无</div>
          </template>
        </div>
        <div class="deliveryList-center" v-for="(item,index) in apiData.deliveryList" :key="index">
          <div class="updateTime">{{ item.time }}</div>
          <div class="deliveryInfo">{{ item.context }}</div>
          <div class="dian"></div>
        </div>
      </div>
    </Drawer>
    <!-- 商品详情 -->
    <Drawer title="" width="400" :closable="false" v-model="diyDom.showshopModal">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          广告详情
        </div>
        <div class="Drawer-content-list">
          <img :src="diyData.shopInfo.img" style="width: 30%"/>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            名称：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.title }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            数量：
          </div>
          <div class="content-item-center">
            x {{ diyData.shopInfo.num}}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.templateId">
          <div class="content-item-title">
            模板：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.templateName || '自定义模板' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.skuInfo">
          <div class="content-item-title">
            规格：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.skuInfo }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.processInfo">
          <div class="content-item-title">
            工序：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.processInfo }}
          </div>
        </div>
        <Divider dashed/>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.designImg">
          <img :src="diyData.shopInfo.designImg" style="width: 30%"/>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.designFile">
          <div class="content-item-title">
            制作源文件：
          </div>
          <div class="content-item-center">
            <a href="javascript:;" @click="lookFile(diyData.shopInfo.designFile)">下载制作源文件</a>
          </div>
        </div>
      </div>
    </Drawer>

  </div>
</template>

<script>
import axios from 'axios'
import {
  apiChangeDetailPrice,
  apiChangePrice,
  apiDeliveryInfo,
  apiEnsurePrice,
  apiOrderinfoSendMake,
  apiOrderinfoSubmitDesign
} from '@/api/order-records.js'
import {getDateTime} from '@/libs/util'
import {apiFactoryOrderInfo, apiFactoryOrderList, apiFactoryOrderSendOut} from "@/api/factory-order";

export default {
  name: 'order-records',
  data() {
    return {

      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      tempUploadUrl: process.env.VUE_APP_API_URL + '/producttemp/upload-file',
      progressPercent: -1, // -1 表示未开始上传
      progressStatus: 'active', // 'active' | 'success' | 'wrong'
      orderNos: '',
      makeCompany: '',
      showChangeModal: false,
      changeForm: {
        orderNo: '',
        price: '',
        type: '1'
      },
      search: {
        nickname: '',
        orderNo: '',
        payNo: '',
        userId: '',
        phone: '',
        type: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        createTimeEnd: '',
        createTimeBegin: ''
      },
      diyDom: {
        showModal: false,
        showDelivery: false,
        showshopModal: false
      },
      form: {
        expressCompany: '',
        expressCompanyCode: '',
        deliveryNo: '',
        orderNo: ''
      },
      formShop: {
        designFile: '',
        designImg: ''
      },
      diyData: {
        orderNos: '',
        orderNo: '',
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '订单号',
            width: '250px',
            key: 'orderNo'
          },
          {
            title: '购买商品',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.title),
                h('p',
                    {
                      style: {display: params.row.qty > 1 ? '' : 'none'}
                    },
                    '等' + params.row.qty + '件商品')
              ])
            }
          },
          {
            title: '状态',
            width: '150px',
            key: 'status',
            render: (h, params) => {
              var color = ''
              switch (params.row.status) {
                case 0:
                  color = '#383838'
                  break
                case 1:
                  color = '#383838'
                  break
                case 2:
                case 100:
                case 200:
                case 300:
                  color = '#383838'
                  break
                case 10:
                  color = '#2A82E4'
                  break
                case -1:
                  color = '#ff0000'
                  break
                case -2:
                  color = '#ff0000'
                  break
                case -9:
                  color = '#ff0000'
                  break

                case -12:
                  color = '#A6A6A6'
                  break
                case -13:
                  color = '#A6A6A6'
                  break
              }
              return h('div', [
                h('span', {
                  style: {
                    color: color
                  }
                }, params.row.statusName)
              ])
            }
          },
          {
            title: '售后',
            width: '80px',
            render: (h, params) => {
              if(params.row.question==1){
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'text',
                      size: 'small'
                    },
                    style: {
                      'color': '#2A82E4'
                    }
                  }, '待处理')
                ]);

              }else{
                return h('div', [
                  h('p', '')
                ])
              }
            }
          },
          {
            title: '收货人/手机号',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.name),
                h('p', params.row.phone)
              ])
            }
          },
          {
            title: '收货地址',
            width: '200px',
            key: 'address'
          },
          {
            title: '下单时间/支付时间',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.createTime),
                h('p', params.row.payTime)
              ])
            }
          },
          {
            title: '发货时间/完成时间',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.acceptTime),
                h('p', params.row.completeTime)
              ])
            }
          },

          {
            title: '操作',
            width: '300px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        width: '60px',
                        marginRight: '10px',
                        fontSize: '14px',
                        display: params.row.status === 1 ? '' : 'none' // 修改: 添加状态判断
                      },
                      on: {
                        click: () => {
                          this.apiData.orderInfo = ''
                          this.diyData.orderNo = params.row.orderNo
                          this.form.orderNo = params.row.orderNo
                          this.diyDom.showModal = true
                          this.getOrderInfo()
                        }
                      }
                    },
                    '发货'
                ),
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px'
                      },
                      on: {
                        click: () => {
                          this.apiData.orderInfo = ''
                          this.diyData.orderNo = params.row.orderNo
                          this.diyDom.showModal = true
                          this.getOrderInfo()
                        }
                      }
                    },
                    '详情'
                ),
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px',
                        display: params.row.status == 2 || params.row.status == 10 ? '' : 'none' // 修改: 添加状态判断
                      },
                      on: {
                        click: () => {
                          this.apiData.orderInfo = ''
                          this.apiData.deliveryList = []
                          this.diyData.orderNo = params.row.orderNo
                          this.diyDom.showDelivery = true
                          this.getOrderInfo()
                          apiDeliveryInfo({orderNo: params.row.orderNo, type: 1}).then(res => {
                            if (res.data.deliveryInfo) {
                              this.apiData.deliveryList = JSON.parse(res.data.deliveryInfo)
                            }
                          })
                        }
                      }
                    },
                    '物流详情'
                )
              ])
            }
          }
        ],
        shopInfo: ''
      },
      apiData: {
        total: 0,
        tableList: [],
        orderInfo: '',
        courierCompany: [],
        deliveryList: []
      }
    }
  },
  methods: {
    changePrice() {
      if (!this.changeForm.price) {
        this.$Notice.error({
          title: '错误',
          desc: '请输入价格'
        });
        return false
      }
      apiChangePrice(this.changeForm).then(res => {
        if (res.code !== 200) {
          return this.$Modal.error({title: '提示', content: res.msg})
        } else {
          this.$Message.success(res.msg)
          this.showChangeModal = false
          this.getTableList()
        }
      })
    },
    // 上传进度回调
    handleProgress(event, file, fileList) {
      if (event.lengthComputable) {
        this.progressPercent = Math.floor((event.loaded / event.total) * 100)
      }
    },
    selectSupplier(e) {
      var orderNos = e.map(res => {
        return res.orderNo
      })
      this.diyData.orderNos = orderNos.join(',')
    },
    deteleDesignFile() {
      this.formShop.designFile = ''
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
    },
    uploadSuccess(type, res, index = 0) {
      if (res.code != 200) {
        this.progressStatus = 'wrong'
        return this.$Modal.error({title: '提示', content: res.msg})
      }
      this.$Message.success('文件上传成功')
      this.progressStatus = 'success'
      if (type == 'designFile') {
        this.formShop.designFile = res.data.fileUrl
      } else if (type == 'designImg') {
        this.formShop.designImg = res.data.fileUrl
      }
    },
    // 文件上传失败
    uploadErr() {
      this.$Spin.hide()
      this.progressStatus = 'wrong'
      this.$Modal.error({
        title: '提示',
        content: '文件上传失败，请重试'
      })
    },

    // 查看文件
    lookFile(url) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.target = '_blank'
      a.href = url
      a.click()
      document.body.removeChild(a)
    },
    // 删除文件
    deleteFile(type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          if (type == 'designFile') {
            this.formShop.designFile = ''
          } else if (type == 'designImg') {
            this.formShop.designImg = ''
          }
        }
      })
    },
    getCourierCompany() {
      var that = this
      axios.get('https://manage.dianggg.com/utils/courierCompany.js').then(function (response) {
        console.log(response.data)
        that.apiData.courierCompany = response.data
      })
    },
    setCourierCompany() {
      var that = this
      this.apiData.courierCompany.forEach(v => {
        if (v.name == that.form.expressCompany) {
          that.form.expressCompanyCode = v.value
        }
      })
    },
    handleCreate(val) {
      var that = this
      this.form.expressCompany = val
      this.apiData.courierCompany.push({
        value: '',
        name: val
      })
    },
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = {...this.search}
      opt.createTimeBegin = getDateTime(this.search.createTimeBegin)
      opt.createTimeEnd = getDateTime(this.search.createTimeEnd)
      apiFactoryOrderList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    getOrderInfo() {
      apiFactoryOrderInfo({orderNo: this.diyData.orderNo}).then(res => {
        this.apiData.orderInfo = res.data
      })
    },
    getOrderinfoSendOut() {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认发货？',
        onOk: () => {
          console.log({...that.form})
          apiFactoryOrderSendOut({...that.form}).then(res => {
            that.$Message.success('发货成功')
            that.diyDom.showModal = false
            that.getTableList()
          })
        }
      })
    },
    lookShop(row) {
      console.log(row)
      this.formShop = {
        designFile: row.designFile,
        designImg: row.designImg
      },
          this.diyData.shopInfo = row
      this.diyDom.showshopModal = true
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
    },
    getupDesign() {
      var obj = {
        orderNo: this.diyData.orderNo,
        designFile: this.formShop.designFile,
        designImg: this.formShop.designImg,
        detailId: this.diyData.shopInfo.id

      }
      apiOrderinfoSubmitDesign(obj).then(res => {
        this.$Message.success('设计图提交成功')
        this.diyDom.showshopModal = false
        this.progressPercent = -1 // -1 表示未开始上传
        this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
        that.getTableList()
      })
    }
  },
  mounted() {
    this.getTableList()
    this.getCourierCompany()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;

}

.Drawer-content {
  width: 100%;

  .status {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 34.75px;
    color: rgba(212, 48, 48, 1);
    text-align: left;
    margin-bottom: 15px;
  }

  .Drawer-content-list {
    width: 100%;
    margin-bottom: 15px;
    display: flex;

    .content-item-title {
      width: 140px;
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 17.38px;
      color: rgba(56, 56, 56, 1);
      text-align: left;
    }

    .content-item-center {
      width: 365px;
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      color: rgba(56, 56, 56, 1);
      text-align: left;

      p {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0px;
        color: rgba(56, 56, 56, 1);
        text-align: left;
      }

      p.name {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(0, 0, 0, 1);
      }

      .content-item-center-box {
        width: 100%;
        padding: 0px 0 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
        margin-bottom: 10px;
        position: relative;

        .content-item-center-box-title {
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0px;
          line-height: 20.27px;
          color: rgba(0, 0, 0, 1);
          margin-bottom: 5px;
        }

        .content-item-center-box-content {
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 17.38px;
          color: rgba(128, 128, 128, 1);
          margin-bottom: 3px;
        }

        .content-item-center-box-price {
          position: absolute;
          top: 50%;
          right: 0px;
          transform: translateY(-50%);

          .priceInput {
            width: 50px;
            margin: 0px 5px;
          }
        }
      }
    }
  }
}

.deliveryList-center {
  width: 100%;
  padding: 0px 10px 20px;
  box-sizing: border-box;
  border-left: 1px solid #FD7247;
  position: relative;

}

.updateTime {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.deliveryInfo {
  font-size: 14px;
  color: #333;
}

.dian {
  position: absolute;
  top: -4px;
  left: -4px;
  width: 6px;
  height: 6px;
  background: #FD7247;
  border-radius: 50%;
  display: block;
}

.upload-Img {
  width: 100px;
  height: 100px;

  .look-img {
    margin-left: 0px;
    width: 100px;
    height: 100px;
    text-align: center;

    img {
      margin-left: 0px;
    }

    .demo-upload-list-cover {
      line-height: 100px;
    }

    .demo-upload-list-cover i {
      line-height: 100px;
    }
  }

  .upload-Img {
    .demo-upload-list-cover i {
      line-height: normal;
    }
  }

  .upload-btn {
    padding-top: 15px;
    width: 100px;
    height: 100px;
    text-align: center;

    p {
      width: 100%;
      text-align: center !important;
    }
  }
}
</style>
